import request from '@/utils/request'

// verifyPhoneNumber
export function verifyPhoneNumber(query) {
  return request({
    url: '/website/ResetPassWordFirst',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/xgmmlc/srsjyz.js